// Allows for configuring different products / houses that are 
// not normal Novasol houses. Leave property blank if it's not to be used.
export const supportedProductCodes = [
  {
    "productCode": "LAND",
    "byline": "A @productIcon holiday park home",
    "iconUrl": "/themes/custom/novasol_theme/images/logos/landal-icon.svg",
    "bookingTxt": "Continue",
    "termsLinkText": "I confirm that the registered information is correct and that I have read and agree with the !astartrental Landal terms!aend. Furthermore I confirm I am at least 18 years of age (for group bookings at least 21 years).",
    "payAtVendor": true
  }
];

export const payAtVendor = (productCode) => {
  if (supportedProductCodes.find(x => x.productCode === productCode)) {
    const product = supportedProductCodes.find(x => x.productCode === productCode);

    if (product.payAtVendor) {
      return true;
    }
  }

  return false;
}
